import React from "react";
import './MahutiInputTimeItem.css'
import { isMobile } from "react-device-detect";
import RadioEmpty from "../../svg/radioEmpty";
import RadioChecked from "../../svg/radioChecked";

export default function MahutiInputTimeItem(props) {

    // יצירת תיאור מלא לקורא מסך
    const getFullDescription = () => {
        const timeDescription = `${props.activityTime.startTime} עד ${props.activityTime.endTime}`;
        const startedWarning = props.activityTime.started ? 'שים לב, הפעילות כבר החלה' : '';
        return `${timeDescription}. ${startedWarning}`;
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            props.setMyTime(props.activityTime);
        }
    };

    return <div className={`mahutiInputTimeItem card rounded-0 p-3 ${props.length > 1 ? 'time_box_border' : ''}`}>
                <div className="card-body p-1">
                    <div className="d-flex align-items-center">
                        <div className="me-4">
                             <div className="radio-wrapper position-relative">
                                <input 
                                    type='radio' 
                                    id={props.lineId} 
                                    className="opacity-0 position-absolute w-100 h-100 top-0 start-0 m-0 cursor-pointer"
                                    name='mahutiInputTimeactivity' 
                                    checked={props.isSelected} 
                                    onKeyDown={handleKeyDown}
                                    onChange={() => props.setMyTime(props.activityTime)}
                                    style={{ zIndex: 1 }}
                                    aria-label={getFullDescription()}
                                />
                                <label className="pointer d-flex" htmlFor={props.lineId}>
                                    {props.isSelected ? <RadioChecked/> : <RadioEmpty/>}
                                </label>
                            </div>
                        </div>
                        <div className="text-start">
                            {/* תוכן לקורא מסך בלבד */}
                            <span className="visually-hidden">
                                {props.activityTime.endTime} - {props.activityTime.startTime}
                            </span>
                            {/* תצוגה ויזואלית */}
                            <span className="fw-bold header-detail" aria-hidden="true">{props.activityTime.startTime}</span>
                            <span className="px-1" aria-hidden="true">-</span>
                            <span className='fw-bold header-detail' aria-hidden="true">{props.activityTime.endTime}</span>
                            {isMobile && <br/>}
                            {props.activityTime.started && 
                                <span className={`fw-bold input_alert time_alert ${!isMobile && 'ms-3'}`} aria-hidden="true">
                                    {!isMobile && 'לתשומת ליבך, '} הפעילות כבר החלה
                                </span>
                            }
                        </div>
                    </div>
                </div>
            </div>
}